import MkuDatePicker from './src/main';

MkuDatePicker.install = function (Vue) {
  Vue.component(MkuDatePicker.name, MkuDatePicker);
};

export default MkuDatePicker;
